import React, { Fragment, useContext } from 'react'
import { Button, Card, Grid, List, ListItem, Message } from 'semantic-ui-react'
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from '../../../App/stores/RootStore'
import { IAdminQuestion } from '../../../App/models/AdminQuestion';
import QuestionForm from './Form/QuestionForm';

const QuestionList: React.FC = () => {
    const rootStore = useContext(RootStoreContext)
    const { AdminQuestionsById } = rootStore.adminQuestionStore;
    const { openModal } = rootStore.modalStore;

    return (
        <Fragment>
            <Button
                className={'rl-btn'}
                onClick={() => openModal(<QuestionForm question={undefined} />)}
                icon='plus'
                content="Create Question"
            />
            <Grid columns={3} divided style={{ overflowY: "auto" }}>
                {AdminQuestionsById.map((adminQuestion: IAdminQuestion) => (
                    <Grid.Column width={8} key={adminQuestion.id}>
                        <Card.Group>
                            <Card fluid>
                                <Card.Content>
                                    <Card.Header>
                                        {adminQuestion.question}
                                    </Card.Header>
                                    <Card.Meta>
                                        <List>
                                            <ListItem>Id: {adminQuestion.id}</ListItem>
                                            <ListItem>Response Type: {adminQuestion.responseType.toString()}</ListItem>
                                            <ListItem>Is an Identity question: {adminQuestion.isIdentity.toString()}</ListItem>
                                            <Button
                                                className={'rl-btn'}
                                                onClick={() => openModal(<QuestionForm question={adminQuestion} />)}
                                                icon='edit'
                                                content="Edit"
                                            />
                                        </List>
                                    </Card.Meta>
                                    <Card.Description>
                                        <Message content={adminQuestion.description} />
                                    </Card.Description>
                                </Card.Content>
                            </Card>
                        </Card.Group>
                    </Grid.Column>
                ))}
            </Grid>
        </Fragment>
    )
}
export default observer(QuestionList);